import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import Select from 'react-select';
import './ComSingleSearch.scss'

// import { fieldOptions, SMjobOptions, freshOptions, schoolOptions, majorOptions, abilityOptions, interestOptions, tagOptions, degreeOptions, companyOptions, lookOptions, yearOptions, paperOptions } from '../SignIn/data';

function ComRaSingleUser(){
  const [state, actions] = useContext(UserContext);

  const [userlist, setUserlist] = useState()
  const [school, setSchool] = useState()
  const [work, setWork] = useState()
  const [resume, setResume] = useState()
  const [paper, setPaper] = useState()

  const [ra, setRa] = useState()

  const [actionbtn, setActionbtn] = useState()

  const [imgurl, setImgurl] = useState()

  const [singleApply, setSingleApply] = useState()
  
  
  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}
  

  let candidate = history.location.pathname.split('/')[3]
  let whichDB = history.location.pathname.split('/')[4]
  let currentRa = history.location.pathname.split('/')[5]
  let currentStatus = history.location.pathname.split('/')[6]

  let hhlink = '';
  let userlink = '';
  let schoollink = '';
  let worklink = '';
  let resumelink = '';
  let paperlink = '';
  let apilink = '';

  if(localStorage.getItem("is_headhunter") === "true") hhlink = "/api/rahh/"
  else if(localStorage.getItem("is_recruiter") === "true") hhlink = "/api/ra/"

  if(currentStatus === "ra") apilink = '/api/ra/?id='
  else apilink = '/api/rahh/?id='

  if(whichDB==="DB2") {
    userlink = "/user/usersecond/?email=" + candidate
    schoollink = "/user/schoolsecond/?email=" + candidate
    worklink = "/user/worksecond/?email=" + candidate
    resumelink = "/user/resumesecond/?email=" + candidate
    paperlink = "/user/papersecond/?email=" + candidate
  }
  else{
    userlink = "/user/userlist/?email=" + candidate
    schoollink = "/user/school/?email=" + candidate
    worklink = "/user/work/?email=" + candidate
    resumelink = "/api/resume/?email=" + candidate
    paperlink = "/api/paper/?email=" + candidate
  }

  function fetchReCart(id, status, step, candidate, which){
    if(window.confirm(candidate + step + "?")){
      fetch(state.awslink + "/api/recartshop/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "id": id,
          "status": status,
          "step": step,
          "candidate": candidate,
          "which": which,
        })
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        // setApplicants(null)
        // fetchSingleRa(id)
        // setChanged(!changed)
        fetchUserResume()
      })
    }
  }

  function fetchApplyStatus(id, status, step, candidate, which){
    if(window.confirm(candidate + step + "?")){
      fetch(state.awslink + "/api/applyStatus/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "id": id,
          "status": status || "7%",
          "step": step,
          "candidate": candidate,
          "which": which,
        })
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        // setApplicants(null)
        fetchUserResume()
        // setChanged(!changed)
      })
    }
  }

  async function fetchUserResume(){
    if(currentRa){
      fetch(state.awslink + apilink + currentRa,{
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(singleRa =>{
        console.log(singleRa)
        fetch(state.awslink + "/api/apply/?id=" + currentRa + 
        "&candi=" + candidate + 
        "&status=" + currentStatus + 
        "&which=" + whichDB
        , {
          method: 'GET',
          headers: header,
        })
        .then(response => response.json())
        .then(json=>{
          console.log(json)
          if(json){
            let resume_id = json.resume
            let templink = ''
            if(resume_id) templink = "&id=" + resume_id
            
            fetch(state.awslink + resumelink + templink, {
              method: 'GET',
              headers: header,
              })
            .then(response => response.json())
            .then(json=>{
              console.log(json)
              // console.log(json.length)

              if(json.length){
                setResume(json[json.length-1])
              }
              else{
                setResume(json)
              }
            })

            if(json.step === "서류합격" ||
            json.step === "최종합격" ||
            json.step === "불합격"
            // || json.step === "기간만료"
            ){
              fetch(state.awslink + userlink + "&real=true", {
              method: 'GET',
              headers: header,
              })
              .then(response => response.json())
              .then(json=>{
                console.log(json)
                setUserlist(json)
              }
              )
            }
  
            // Exists
            let userdb
            let whichdb
            if(json.user) {userdb = json.user.email; whichdb = "DB1"}
            else if(json.userSecond) {userdb = json.userSecond.email; whichdb = "DB2"}
  
            // 리크루터 / 헤드헌터에 따라서 applyview get 다르게 보내줄거
            // 그니간 조건문은 헤드헌터만 따면됨
            if(json.step === "지원완료" || json.step === "추천"){
                if(email === singleRa.user.email)
                  setActionbtn(<>
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "서류합격", userdb, whichdb )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "불합격", userdb, whichdb )}>불합격</button>
                  </div></>)
                }
            else if(json.step === "기간만료" || json.step === "최종합격")
              setActionbtn(<>
                <div>
                  <button className={"disabled"}>
                    {json.step}
                  </button>
                </div></>)
            else if(json.step === "제안보냄" || json.step === "추천제안")
              // 어쩌피 헤드헌터일떄만 날라올거, 그냥 보여주면 됨 위에랑 합칠수도?
              setActionbtn(<>
                <div>
                  <button className={"disabled"}>
                    {json.step}
                  </button>
                </div></>)
            else if(json.step === "서류합격"){
              if(email === singleRa.user.email)
                setActionbtn(<>
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "최종합격", userdb, whichdb )}>최종합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "불합격", userdb, whichdb )}>불합격</button>
                  </div>
                </>)
              }
            else if(json.step === "장바구니")
              // if(email === singleRa.user.email)
                setActionbtn(<>
                  <div>
                    {email === singleRa.user.email && 
                      <button style={{color: "black"}} onClick={()=>fetchReCart( 
                        singleRa.id, singleRa.status, "제안보냄", userdb, whichdb  )}>지원제안</button>}
                    
                    {localStorage.getItem("is_headhunter") === "true" && email !== singleRa.user.email && 
                      <button style={{color: "black"}} onClick={()=>fetchReCart( 
                        singleRa.id, singleRa.status, "추천제안", userdb, whichdb )}>추천제안</button>}
                    
                    <button style={{color: "black"}} onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "불합격", userdb, whichdb )}>불합격</button>
                  </div>
                </>)
            else if(json.step === "추천수락")
              // 남에꺼일때만 인데 comraboarddetail도 체크
              // if(email === singleRa.user.email)
              setActionbtn(<>
                <div>
                  <button style={{color: "black"}}onClick={()=>fetchReCart( 
                    singleRa.id, singleRa.status, "추천", userdb, whichdb )}>추천하기</button>
                  <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                    singleRa.id, singleRa.status, "불합격", userdb, whichdb )}>불합격</button>
                </div>
              </>)
            
            else if(json.step === "제안수락")
              // 내꺼일떄만, 아닐떈 null
              if(email === singleRa.user.email)
                setActionbtn(<>
                  <div>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "서류합격", userdb, whichdb )}>서류합격</button>
                    <button style={{color: "black"}}onClick={()=>fetchApplyStatus( 
                      singleRa.id, singleRa.status, "불합격", userdb, whichdb )}>불합격</button>
                  </div>
                </>)
          }
          else{
            setActionbtn(
              <>   
              </>
            )
          }
        }
        )
        .catch(err => {
          console.log(err)
        })
        
        
      })

      
    }
    else{
      fetch(state.awslink + resumelink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setResume(json[0])
      }
      )
    }
  }

  useEffect(()=>{

    // async function fetchApplyById(){
    //   fetch(state.awslink + 
    //     "/api/apply/?id=" + currentRa + 
    //   '&candi=' + candidate, {
    //     method: 'GET',
    //     headers: header,
    //     })
    //     .then(response => response.json())
    //     .then(json=>{
    //       console.log(json)
    //       setSingleApply(json)
    //     })
    // }
    
    async function fetchRalist(){
      fetch(state.awslink + hhlink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        // let arr = []
        let newobj = [];

        if(hhlink === "/api/rahh/"){
          if(json["ra"])
            if(json["ra"].length)
              {json["ra"].map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })}
          if(json["ra_shop_hh"])
            if(json["ra_shop_hh"].length)
              {json["ra_shop_hh"].map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })}
          if(json["ra_shop_7"])
            if(json["ra_shop_7"].length)
              {json["ra_shop_7"].map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })}
            // console.log(arr)
          setRa(newobj)
        }
        else{
          let newobj = []
          if(json)
            if(json.length)
              json.map((item, index)=>{
                newobj.push({"value": item.title, "label": item.title, "id": item.id, "status": item.status})
                return null
              })
          
          setRa(newobj)
        }
        
      }
      )
    }

    async function fetchUserlist(){
      fetch(state.awslink + userlink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setUserlist(json)
      }
      )
    }

    async function fetchUserSchool(){
      fetch(state.awslink + schoollink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setSchool(json)
      }
      )
    }
    
    async function fetchUserWork(){
      fetch(state.awslink + worklink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setWork(json)
      }
      )
    }

    async function fetchUserPaper(){
      fetch(state.awslink + paperlink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setPaper(json)
      }
      )
    }

    


    // fetchApplyById();
    if(!state.tempuser){
      fetchRalist();
    }
    // console.log(state.tempuser)
    fetchUserlist()
    fetchUserSchool()
    fetchUserWork()
    fetchUserResume()
    fetchUserPaper()
    
  },[])

  // console.log(applicant[0].email)
  // if(ralist === null){
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  function fetchCart(e, step){
    console.log(e)
    // console.log(e.id)
    if(step === "추천"){
      if(whichDB === "DB1") {step = "추천제안"}
      // else일때 내꺼인지 아닌지 구분
      else {
        if(email === userlist.user["email"]){
          step = "추천"
        }
        else {step = "추천제안"}
      }
    }

    console.log(whichDB, step)
    fetch(state.awslink + "/api/recartshop/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "candidate": candidate,
        "step": step,
        "status": e.status,
        "which": whichDB,
        "id": e.id
      })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setResume(json)
      })

      let add_link
      if(e.status === "7%") add_link = "ra"
      else add_link = "rahh"
    
      history.push('/recruiter/raboard/' + e.id + '/' +add_link )
    
  }

  // console.log(ra, SMjobOptions)
  // console.log(email, userlist.user["email"])
  console.log(userlist, school,work,resume,paper)
  // console.log(state)
  return(
    <>
    {state.width < state.breakpoint ? null
      :
      <Wrapper>
        <RaWrapper>

          
          {userlist&& school&&work&&resume&&paper &&
            <>
              <ProfileForm>
                <HeaderForm >
                  <ImgWrapper>
                    <img 
                      src = {userlist.profilelink ? userlist.profilelink : "dummy"} 
                      onError={(e)=> {
                          e.target.src = state.noimage
                      }}
                      alt = 'profile'
                    />
                    <div className={"name"}>{userlist.realname}</div>

                  </ImgWrapper>

                  <div>
                    {actionbtn? 
                    <div>
                      {actionbtn}
                    </div>
                    :
                    <div>
                      {ra && 
                      <>
                        <Select
                          className="choice-single"
                          defaultValue={{label: "장바구니"}}
                          // isSearchable={true}
                          
                          options={ra}
                          onChange={(e)=>{fetchCart(e, "장바구니")}}
                        />
                        {localStorage.getItem("is_headhunter") === "true" &&
                          <Select
                            className="choice-single"
                            defaultValue={{label: "추천하기"}}
                            // isSearchable={true}
                            options={ra}
                            onChange={(e)=>{fetchCart(e, "추천")}}
                          />
                        }
                        
                        <Select
                          className="choice-single"
                          defaultValue={{label: "면접제안"}}
                          // isSearchable={true}
                          
                          options={ra}
                          onChange={(e)=>{console.log(e)}}
                        />
                        </>
                      }
                    </div>
                    }
                    
                  </div>

                </HeaderForm>
              
                <ContentForm>
                  <div>
                    <h4>
                      직무
                    </h4>
                    <div>
                      {userlist.field} - {userlist.job}
                    </div>
                  </div>

                  <div>
                    <h4>
                      요소기술
                    </h4>
                    <div className={"ras-tag"}>
                      {resume.abilities &&
                      resume.abilities.map((item)=>{
                        return(<div>{item}</div>)
                      })}
                    </div>
                  </div>

                  <div>
                    <h4>
                      태그
                    </h4>
                    <div className={"ras-tag"}>
                      {resume.tag &&
                      // userlist.tag.length &&
                       resume.tag.map((item)=>{
                        return(<div>{item}</div>)
                      })}
                    </div>
                  </div>

                  <div>
                    <h4>
                      도메인
                    </h4>
                    <div className={"ras-tag"}>
                      {userlist.domain && userlist.domain.map((item)=>{
                        return(<div>{item}</div>)
                      })}
                    </div>
                  </div>

                  <div>
                    <h4>
                      특장점
                    </h4>
                    <div>
                      {resume.strength}
                    </div>
                  </div>
                    
                  

                  <div>
                    <h4>
                      경력
                    </h4>
                    <div className={"ras-work"}>
                      {work.map((item)=>{
                        return(
                          <div>
                            <h4>
                              {item.title}
                            </h4>
                            <div className={"qu-add"}>
                              {item.depart}
                            </div>
                            <div className={"qu-add"}>
                              {item.start} - {item.end}
                            </div>

                            {/* EditorState? */}
                            <div className={"ras-work-memo"}>
                              {item.memo}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  
                  <div>
                    <h4>
                      학력
                    </h4>
                    <div className={"ras-work"}>
                      {school.map((item)=>{
                        return(
                          <div>
                            <h4>
                              {item.title}
                            </h4>

                            <div className={"qu-add"}>
                              {item.major}
                            </div>

                            <div className={"qu-add"}>
                              {item.degree} 
                              {item.degree === "박사(통합) 과정" || item.degree === "박사(통합) 졸업" || item.degree === "석사 과정" || item.degree === "석사 졸업"
                              ? " / " + item.prof: null}
                            </div>

                            <div className={"qu-add"}>
                              {item.start}
                              {item.end !== "undefined/undefined" 
                              && " - " + item.end}
                            </div>

                            {/* EditorState? */}
                            <div className={"ras-work-memo"}>
                              {item.memo}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>

                  <div>
                    <h4>
                      기타
                    </h4>
                    <div className={"ras-work"}>
                      <div>
                        <h4>논문</h4>
                        <ul>
                          {paper.map((item)=>{
                            return(
                              <li>
                                {/* <span>● </span> */}
                                {item.paperTitle}
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>

                    <div className={"ras-work"}>
                      <div>
                        <h4>수상</h4>
                        <ul>
                          {resume.awards && 
                          resume.awards.map((item)=>{
                            return(
                              <li>
                                {/* <span>● </span> */}
                                {item}
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>

                    <div className={"ras-work"}>
                      <div>
                        <h4>특허</h4>
                        <ul>
                          {resume.patents && 
                          resume.patents.map((item)=>{
                            return(
                              <li>
                                {/* <span>● </span> */}
                                {item}
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>
                    
                    <div className={"ras-work"}>
                      <div>
                        <h4>언어</h4>
                        <ul>
                          <li>
                            <div className={"ras-tag"}>
                              {resume.languages && 
                              resume.languages.map((item)=>{
                                return(<div>{item}</div>)
                              })}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>                      
                  </div>

                  <div>
                    <h4>
                      자기소개
                    </h4>
                    <div>
                      {resume.intro}
                    </div>
                  </div>
                  
                </ContentForm>
              </ProfileForm>


              <RightForm>

              </RightForm>
            </>
          }
          
        
        </RaWrapper>
      </Wrapper>   
      }
    </>
  )
}


const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: flex;
  margin: 0 auto;
  background-color: whitesmoke;
`


const ProfileForm = styled.div`
  width: 70%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 0px;
  display: flex;
  margin: 0;
  flex-wrap: wrap;
  text-align: left;
  vertical-align: top;

  /* min-height: 300px; */

`

const HeaderForm = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;

    min-height: 300px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px 5px 0px 0px;
    border-bottom: none;

    >div{
      :last-child{
        /* margin-top: 60px; */
        display: flex;
        width: 100%;
        justify-content: flex-end;
        position: absolute;
        right: 20px;
        bottom: 20px;
        flex-direction: column;
        >div{
          display: flex;
          justify-content: flex-end;
          
          .choice-single{
            width: 150px;
            margin-left: 10px;
            font-size: .9rem;
            >div{
              width: 100%;
            }
          }
          /* :first-child{
            margin-bottom: 20px;
          } */
          >div{
            display: inline-flex;
            
            button{
              background-color: rgba(253,134,18, 0.8);
              padding: 7px;
              /* border: 1px solid rgba(150, 150, 150, 0.4); */
              border-radius: 10px;
              color: white !important;
              cursor: pointer;
              transition: .2s;
              width: 100px;
              border: none;
              margin-left: 20px;
              height: 35px;
              font-size: 1.00rem;
              font-weight: bold;
              
              :hover{
                background-color: rgba(253,134,18, 0.9);
              }
              :active{
                background-color: rgba(253,134,18, 1);
              }
              :last-child{
                color: rgba(253,134,18, 0.8) !important;
                background-color: transparent;
                border: .5px solid rgba(253,134,18, 0.8);
                cursor: not-allowed;
                :hover{
                  background-color: rgba(253,134,18, 0);
                }
                :active{
                  background-color: rgba(253,134,18, 0);
                }
              }

            }
          }

        }
      }
    }
`

const ContentForm = styled.div`
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 5px 5px;
    border-bottom: .5px solid rgba(0,0,0,0.2);

    >div{
      margin-bottom: 20px;
      font-size: 0.9rem;
      h4{
        margin: 0;
        padding-top: 20px;
        padding-bottom: 20px;
        font-weight: 600;
        opacity: .6;
      }
      >div{
        padding-left: 20px;
        font-size: 0.9rem;
      }
      .ras-tag{
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
          margin-left: 0;
          margin-right: 10px;
        }
      }
      .ras-work{
        margin-bottom: 10px;
        h4{
          font-size: .9rem;
          padding-top: 0px;
          padding-bottom: 5px;
          opacity: 1;
        }
        .ras-work-memo{
          font-size: .9rem;
          /* margin-top: 10px; */
          margin-bottom: 10px;
        }
        /* span{
          display: inline-flex;
          justify-content: center;
          align-items: center;
        } */
        ul{
          padding-left: 20px;
        }
      }
    }
`




const ImgWrapper=styled.div`
  display: flex;
  height: 200px;
  width: 100%;

  justify-content: center;
  align-items: center;

  flex-direction: column;
  
  /* margin-bottom: 20px; */
  >img{
    width: 80px;
    height: 80px;
    border-radius: 50px;
    margin-bottom: 10px;
  }
  >div{
    margin-top: 3px;
    margin-bottom: 3px;
    font-size: 0.8rem;
    opacity: .6;
    
  }
  .name{
    font-size: .9rem;
    opacity: 1;
  }

`

const RightForm = styled.div`
  width: 30%;
  box-sizing: border-box;
  padding: 5px;
  padding-right: 0px;
  display: inline-block;
  margin: 0;
  
  text-align: left;
  vertical-align: top;
  
`

export default ComRaSingleUser